import { format } from 'date-fns'
import { DATES_FORMAT_FULL_YEAR_SHORT_MONTH, DATES_FORMAT_MONTH_DAY } from '../../../constants/dates'
import { DATE_STATIC_PRESET, staticPeriodsListWithCustom } from '../../../constants/selectLists/listItemFiltersList'

export function getStaticRangeLabel(staticRange) {
  return staticPeriodsListWithCustom.find(period => period.value === staticRange)?.label
}

export function getMobileDateRangeLabel(startDate, endDate) {
  return `${format(startDate, DATES_FORMAT_MONTH_DAY)} - ${format(endDate, DATES_FORMAT_MONTH_DAY)}`
}

export function getDateRangeLabel(startDate, endDate) {
  return `${format(startDate, DATES_FORMAT_FULL_YEAR_SHORT_MONTH)} - ${format(endDate, DATES_FORMAT_FULL_YEAR_SHORT_MONTH)}`
}

export const getDateRangePDFReportLabel = dateRange => {
  const staticRange = dateRange[DATE_STATIC_PRESET]

  return staticRange ? getStaticRangeLabel(staticRange) : getDateRangeLabel(dateRange.startDate, dateRange.endDate)
}
